import { useContext, useEffect } from "react";
import TikTokPixel from 'tiktok-pixel';
import { useTrackingPixels } from "../../hooks/useTrackingPixels";
import { CheckoutContext } from "../../contexts/CheckoutContext";
import useTikTokPixels from "../../hooks/useTikTokPixels";


export default  function TikTokPixels(){
    const trackingPixels = useTrackingPixels();
    const { offer } = useContext(CheckoutContext);
    const { onCheckoutVisit } = useTikTokPixels()

    useEffect(() => {
        trackingPixels.tiktok_pixels.forEach(pixel => {
            TikTokPixel.init(pixel.pixelId);

        })

        if(offer){
            onCheckoutVisit()
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[trackingPixels])

    return null
}